// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-34ca76b8] .modules-text{margin:1rem;margin-left:1.2rem !important;font-size:14px !important}[data-v-34ca76b8] .modules-text h6{font-size:15px !important}[data-v-34ca76b8] .bottom-buttons{margin-left:5px}[data-v-34ca76b8] .ag-cell-wrapper{display:block !important}", ""]);
// Exports
module.exports = exports;
